// extracted by mini-css-extract-plugin
export default {"comercial":"Comercial_comercial__MlyIY","imgContainer":"Comercial_imgContainer__f6nnG"};